import { PrioritizeListItem } from './prioritizelistItem.model';

export class AttributeOption implements PrioritizeListItem {
  id: number;
  name: string;
  priority: number;
  active: boolean;
  price: number;
  uiId?: number;
  maxAmountOfRegistrations: number;
  registered: number;
  isDisabledForDependencySelect: boolean;
  hasAttributeDependencies?: boolean;
  nonRefundable: boolean;

  constructor(initValue?: Partial<AttributeOption>) {
    Object.assign(this, initValue);
  }

  public copy(): AttributeOption {
    return Object.assign(new AttributeOption(), this, { id: undefined, registered: 0 });
  }

  static BuildOption(uiId: number, name: string) {
    const option = new AttributeOption();
    option.id = 0;
    option.active = true;
    option.name = `${name}`;
    option.price = 0;
    option.priority = 0;
    option.uiId = uiId;
    option.maxAmountOfRegistrations = 0;
    option.registered = 0;
    option.nonRefundable = false;
    return option;
  }

  static transformToAttributeOption(optionData: AttributeOption, hasAttributeDependencies: boolean): AttributeOption {
    let option = new AttributeOption();
    option.id = optionData.id;
    option.active = optionData.active;
    option.name = optionData.name;
    option.price = optionData.price;
    option.nonRefundable = optionData.nonRefundable;
    option.priority = optionData.priority;
    option.uiId = optionData.uiId;
    option.maxAmountOfRegistrations = optionData.maxAmountOfRegistrations;
    option.registered = optionData.registered;
    option.isDisabledForDependencySelect = optionData.isDisabledForDependencySelect;
    option.hasAttributeDependencies = hasAttributeDependencies;

    return option;
  }
}
